module.exports = __webpack_public_path__ + "img/k2.00cdf627.png";